import { createStyles, Theme } from '@material-ui/core'

const ActivityLogModalStyles = (theme: Theme) => createStyles({
  activityDescription: {
    color: theme.palette.grey[`500`],
    wordBreak: `break-word`,
  },
  dialogContent: {
    minWidth: 300,
    paddingRight: 0,
    paddingLeft: 0,
  },
  dialogTitleRoot: {
    padding: theme.spacing(1),
  },
  activityDate: {
    color: theme.palette.grey[`500`],
    paddingRight: theme.spacing(1) * 2,
  },
  listItemRoot: {
    paddingBottom: theme.spacing(1) * 2,
    paddingLeft: theme.spacing(1) * 3,
    paddingRight: 0,
    paddingTop: theme.spacing(1) * 2,
  },
})

export default ActivityLogModalStyles
